// sf-logger.js (pixel + IP avec fallback JSONP, robuste)
(function () {
  const WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbwaPwv8fTdkr8bleHCizMQzw5WFfPCOJeOP7LdZc9xQpcIpyCxQ8UgjWJL7EMjGEtCQsg/exec';
  let ipCache = null;

  // ---- helpers ----
  function jsonp(baseUrl) {
    return new Promise(resolve => {
      const cb = '__sf_cb_' + Math.random().toString(36).slice(2);
      const s = document.createElement('script');
      window[cb] = function (data) {
        try { delete window[cb]; } catch (_) {}
        s.remove();
        const ip = (data && (data.ip || data.address || '') || '').toString().trim();
        resolve(ip || '');
      };
      s.onerror = function () {
        try { delete window[cb]; } catch (_) {}
        s.remove();
        resolve('');
      };
      s.src = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'callback=' + cb;
      document.head.appendChild(s);
      setTimeout(() => { try { delete window[cb]; } catch (_) {} s.remove(); resolve(''); }, 3000);
    });
  }

  async function getIP() {
    if (ipCache) return ipCache;

    // 1) Tentatives via fetch (si autorisé par la page)
    const endpoints = [
      'https://api.ipify.org?format=json',
      'https://ipapi.co/json',
      'https://ipwho.is/?output=json'
    ];
    for (const url of endpoints) {
      try {
        const r = await fetch(url, { cache: 'no-store' });
        if (!r.ok) continue;
        const d = await r.json();
        const ip = d.ip || d.query || '';
        if (ip) { ipCache = ip; return ip; }
      } catch (_) {}
    }

    // 2) Fallback JSONP (contourne CORS)
    const jsonpEndpoints = [
      'https://api.ipify.org?format=jsonp',
      'https://jsonip.com/'
    ];
    for (const u of jsonpEndpoints) {
      const ip = await jsonp(u);
      if (ip) { ipCache = ip; return ip; }
    }
    return '';
  }

  function send(payload) {
    const q = new URLSearchParams(payload);
    q.append('ts', Date.now()); // anti-cache
    const img = new Image(1, 1);
    img.referrerPolicy = 'no-referrer';
    img.src = WEBHOOK_URL + '?' + q.toString();
    (window.__sf_imgs || (window.__sf_imgs = [])).push(img); // évite GC
  }

  async function log(tag) {
    const ip = await getIP();
    send({
      ip: ip || '',
      ua: navigator.userAgent || '',
      page: location.href,
      ref: document.referrer || '',
      tag: tag || ''
    });
  }

  // Tests manuels (2 alias)
  window._sfPing = function () { log('MANUAL_PIXEL'); };
  window.sfPing  = window._sfPing;

  // Crochets discrets
  document.addEventListener('submit', function () { log('SUBMIT'); }, true);
  document.addEventListener('click', function (e) {
    const el = e.target && e.target.closest && e.target.closest('button[type=submit],input[type=submit]');
    if (el) log('CLICK_SUBMIT');
  }, true);

  // Précharger l'IP dès l'arrivée sur la page pour que SUBMIT ait déjà la valeur
  getIP();
})();
